import React from 'react';
import { HeroSection } from './components/HeroSection';
import { BoatTypesSection } from './components/BoatTypesSection';
import { WhyChooseSection } from './components/WhyChooseSection';
import { AboutSection } from './components/AboutSection';
import { GallerySection } from './components/GallerySection';
import { ProcessSection } from './components/ProcessSection';
import { ReviewsSection } from './components/ReviewsSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="font-['Inter_Tight',sans-serif] text-gray-800 bg-gray-50 w-full" data-id="element-0">
      <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-1" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" data-id="element-2" />
      <link href="https://fonts.googleapis.com/css2?family=Inter+Tight:wght@300;400;500;600;700&display=swap" rel="stylesheet" data-id="element-3" />
      <HeroSection data-id="element-4" />
      <BoatTypesSection data-id="element-5" />
      <WhyChooseSection data-id="element-6" />
      <AboutSection data-id="element-7" />
      <GallerySection data-id="element-8" />
      <ProcessSection data-id="element-9" />
      <ReviewsSection data-id="element-10" />
      <Footer data-id="element-11" />
      <WhatsAppButton data-id="element-12" />
    </div>;
}